{
  "mandatoryFields": {
    "part1": "Fields marked with a",
    "part2": "are mandatory"
  },
  "confirm": {
    "leave": {
      "page": {
        "title": "Leave the page?",
        "message": {
          "unsavedData": "Updates have been done and will not be saved. Do you want to leave the page?"
        }
      }
    },
    "okLabel": "Confirm",
    "cancelLabel": "Cancel",
    "cancel": {
      "title": "Cancel changes?",
      "message": "Changes have been done and will not be saved. Do you confirm cancelling changes?"
    }
  },
  "noData": "No data"
}
